import { Pipe, PipeTransform } from '@angular/core';
import { buildConjunction } from '../../utils/conjunction/conjunction.utils';

@Pipe({
  name: 'conjunction',
  standalone: true,
})
export class ConjunctionPipe implements PipeTransform {
  transform(value: string[], conjunction: string): string {
    return buildConjunction(value, conjunction);
  }
}
